import { useBrand } from '@contexts/useBrand'
import { useFormContext } from 'react-hook-form'
import { twMerge } from 'tailwind-merge'

type Props = {
  name: string
  label: string
  value: boolean | string
  checked?: boolean
  errorDisabled?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const RadioButton = ({ name, label, errorDisabled, ...rest }: Props) => {
  const brand = useBrand()
  const { register, getFieldState, formState } = useFormContext()
  const { error } = getFieldState(name, formState)

  return (
    <div
      data-gt-name="componentevent"
      className="flex items-center text-base-text"
    >
      <input
        id={`${name}-${rest.value}`}
        className={twMerge(
          `size-5 text-base-text cursor-pointer hover:bg-base-hover checked:border-base checked:bg-transparent ${
            brand === 'kinto'
              ? "checked:bg-[url('/img/kinto-circle.svg')]"
              : "checked:bg-[url('/img/circle.svg')]"
          } checked:hover:bg-transparent checked:hover:border-base checked:focus:bg-transparent checked:focus:border-base`,
          error && 'border-red',
          errorDisabled && 'cursor-default',
        )}
        type="radio"
        data-gt-action="radio-input-interaction"
        data-gt-label={name}
        {...register(name)}
        {...rest}
      />
      <label
        htmlFor={`${name}-${rest.value}`}
        className="flex items-center cursor-pointer"
      >
        <span className={`pl-3 mr-8 ${error && 'text-red'}`}>{label}</span>
      </label>
      {error && !errorDisabled && <p>{error.message}</p>}
    </div>
  )
}

export default RadioButton
